var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCdmoContractDevelopmentIcon1(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.0009 1V13C21.0006 13.671 21.1691 14.3312 21.4909 14.92L32.5109 35.08C32.8443 35.6892 33.0132 36.3747 33.0013 37.0691C32.9893 37.7634 32.7967 38.4427 32.4425 39.04C32.0884 39.6373 31.5848 40.1322 30.9813 40.4759C30.3779 40.8195 29.6954 41.0002 29.0009 41H5.00093C4.30648 41.0002 3.62396 40.8195 3.02051 40.4759C2.41706 40.1322 1.91347 39.6373 1.55931 39.04C1.20514 38.4427 1.01259 37.7634 1.0006 37.0691C0.988607 36.3747 1.15759 35.6892 1.49093 35.08L12.5109 14.92C12.8327 14.3312 13.0012 13.671 13.0009 13V1",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M5.90723 27H28.0952",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.001 1H24.001",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCdmoContractDevelopmentIcon1);
export default __webpack_public_path__ + "static/media/cdmo-contract-development-icon1.3bd6a7f20bce7f5f207982ef3df2f418.svg";
export { ForwardRef as ReactComponent };